// extracted by mini-css-extract-plugin
export var csatScore = "_kx-5";
export var header = "_kx-1";
export var panelWrapper = "_kx-2";
export var postPreview = "_kx-3";
export var rightContent = "_kx-0";
export var wrappingText = "_kx-4";